import { useState } from "react";
import { CalendarRange } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const iso = (d) => d.toISOString().slice(0, 10);
const today = () => new Date();
const shiftDays = (n) => {
  const d = today();
  d.setDate(d.getDate() - n);
  return d;
};
const monthStart = (delta = 0) => {
  const d = today();
  return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + delta, 1));
};
const monthEnd = (delta = 0) => {
  const d = today();
  return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + delta + 1, 0));
};

export const PRESETS = {
  hoje: { label: "Hoje", range: () => [iso(today()), iso(today())] },
  "7dias": { label: "7 dias", range: () => [iso(shiftDays(6)), iso(today())] },
  mes: { label: "Este mês", range: () => [iso(monthStart()), iso(monthEnd())] },
  anterior: { label: "Mês anterior", range: () => [iso(monthStart(-1)), iso(monthEnd(-1))] },
  "3meses": { label: "3 meses", range: () => [iso(monthStart(-2)), iso(monthEnd())] },
  ano: {
    label: "Este ano",
    range: () => [`${today().getUTCFullYear()}-01-01`, iso(monthEnd())],
  },
};

export function PeriodPicker({ value, onChange }) {
  const [custom, setCustom] = useState(false);
  const [range, setRange] = useState(value);

  const apply = () => {
    if (range.start && range.end && range.start <= range.end) onChange(range);
  };

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="finance-period-picker">
      {Object.entries(PRESETS).map(([key, p]) => (
        <button
          key={key}
          onClick={() => {
            setCustom(false);
            const [start, end] = p.range();
            onChange({ start, end, preset: key });
          }}
          data-testid={`period-${key}`}
          className={`rounded-full border px-3 py-1.5 text-xs transition-colors ${
            value.preset === key && !custom
              ? "border-brand/50 bg-brand/15 text-brand"
              : "border-white/10 text-muted-foreground hover:text-foreground"
          }`}
        >
          {p.label}
        </button>
      ))}
      <button
        onClick={() => setCustom((c) => !c)}
        data-testid="period-custom"
        className={`flex items-center gap-1 rounded-full border px-3 py-1.5 text-xs transition-colors ${
          custom
            ? "border-brand/50 bg-brand/15 text-brand"
            : "border-white/10 text-muted-foreground hover:text-foreground"
        }`}
      >
        <CalendarRange className="h-3.5 w-3.5" /> Personalizado
      </button>

      {custom && (
        <div className="flex w-full flex-wrap items-center gap-2 sm:w-auto">
          <Input
            type="date"
            value={range.start}
            onChange={(e) => setRange((r) => ({ ...r, start: e.target.value, preset: null }))}
            className="h-9 w-full sm:w-40"
            data-testid="period-start-input"
          />
          <Input
            type="date"
            value={range.end}
            onChange={(e) => setRange((r) => ({ ...r, end: e.target.value, preset: null }))}
            className="h-9 w-full sm:w-40"
            data-testid="period-end-input"
          />
          <Button size="sm" onClick={apply} className="h-9 rounded-full" data-testid="period-apply-btn">
            Aplicar
          </Button>
        </div>
      )}
    </div>
  );
}
